import React, { useRef } from 'react';
import { useMutation } from '@apollo/client';
import UploadImageMutation from './UploadImageMutation';

interface IUploadImageConnectorApolloProps {
  children: ({
    uploadImage,
    cancelUploadImage,
  }: {
    uploadImage: (image: File, scope: string) => Promise<unknown>;
    cancelUploadImage: () => void;
  }) => React.ReactElement;
}

const UploadImageConnectorApollo: React.FC<IUploadImageConnectorApolloProps> = ({ children }) => {
  const [uploadImageMutation] = useMutation(UploadImageMutation);
  const abortControllerRef = useRef<AbortController | null>(null);

  const uploadImage = async (image: File, scope: string) => {
    abortControllerRef.current = new AbortController();

    const response = await uploadImageMutation({
      variables: { image, scope },
      context: {
        fetchOptions: {
          signal: abortControllerRef.current.signal,
        },
      },
    });

    return response.data?.dailyTracker?.uploadImage;
  };

  const cancelUploadImage = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
  };

  return children({ uploadImage, cancelUploadImage });
};

export default UploadImageConnectorApollo;
